import React from "react";
import PropTypes from "prop-types";
import { Timeline } from "primereact/timeline";
import "./timeline.scss";

const Timelines = ({ events, markerTemplate, contentTemplate }) => {
  return (
    <Timeline
      value={events}
      content={contentTemplate}
      marker={markerTemplate}
    />
  );
};
Timelines.propTypes = {
  events: PropTypes.array,
  markerTemplate: PropTypes.array,
  contentTemplate: PropTypes.node,
};
export default Timelines;
